export default __webpack_public_path__ + "static/media/b64.902fe169.png";